import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogisticsService {

  constructor(private http: HttpClient) { }

  /**
   * Check if this target forwarder is express or not.
   * @param forwarder Forwarder code
   * @param facility Facility code
   */
  isExpressBill(forwarder: string, facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Logistics/ExpressBill`;
    const params = new HttpParams()
      .append('forwarderCode', isNullOrEmpty(forwarder) ? '' : forwarder)
      .append('facilityCode', isNullOrEmpty(facility) ? '' : facility);

    return this.http.get(url, { params });
  }

  markReturnDelivery(bookingNo: string, reasons: any[], userId?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/returnDelivery`;
    const params = {
      bookingNo,
      reasons,
      userId
    };
    return this.http.post(url, params);
  }

  markReturnWareHouse(bookingNo: string, reasons: any[], userId?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/returnWarehouse`;
    const params = {
      bookingNo,
      reasons,
      userId
    };
    return this.http.post(url, params);
  }

  getAllRate(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/rate/Corporate`;
    return this.http.get(url);
  }

  isFeeCalCulation(feature: string, bookingNo: string, status: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/isFeeCalCulation/${feature}/${bookingNo}/${status}`;
    return this.http.get(url);
  }
}
